import { useEffect, useState } from 'react';

import { pageTitle as pageTitleService } from 'services/pageTitle';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { TabItem } from 'components/DesignSystem/Tabs';
import { REPORTS_LIST_TABLE, USE_TEMPLATE_FOR_REPORT } from 'components/widgets/ReportsHome/ReportsHome.consts';

export type ReportingTabKeys = typeof REPORTS_LIST_TABLE | typeof USE_TEMPLATE_FOR_REPORT;

export const useReportsHomeLogic = () => {
    const [activeTab, setActiveTab] = useState<ReportingTabKeys>(REPORTS_LIST_TABLE);

    const tabList: TabItem[] = [
        {
            value: REPORTS_LIST_TABLE,
            label: 'Reports',
            icon: <MuiIcon icon={'analytics'} type={'outlined'} fontSize={'2.25rem'} />,
        },
        {
            value: USE_TEMPLATE_FOR_REPORT,
            label: 'Templates',
            icon: <MuiIcon icon={'dashboard'} type={'outlined'} fontSize={'2.25rem'} />,
        },
    ];

    useEffect(() => {
        pageTitleService.set('Reporting');
    }, []);

    return {
        logic: {
            activeTab,
            setActiveTab,
            tabList,
        },
    };
};
